<template>
  <div class="form-columns">
    <div class="form-side-text">{{$t('signup.sideText')}}
    </div>

    <div class="form-container">
      <div class="header">
        <div class="closeButton">
          <button class="btn theme-close-button" @click="home">
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <h2>{{$t('signup.register')}}</h2>
      </div>
      
      <div class="fieldsContainer"> 

        <div class="input">
            <div style="flex: 1;"><input id="emailField" v-model="emailInput" v-on:keyup.enter="signUp" class="themeInput" type="text" placeholder="e-mail" autofocus></div>
            <div><font-awesome-icon icon="envelope" class="inputImage"/></div>
        </div>        

        <div class="validation">
            <font-awesome-icon v-if="emailValid" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.validEmail')}}
        </div>

        <div class="input">
            <div style="flex: 1;"><input v-model="usernameInput" v-on:keyup.enter="signUp" class="themeInput" type="text" :placeholder="$t('signin.username')" autofocus></div>
            <div><font-awesome-icon icon="user" class="inputImage"/></div>
        </div>        
        <div class="validation">
          <font-awesome-icon v-if="usernameLengthOk" class="text-green" icon="check"/>
          <font-awesome-icon v-else class="text-red" icon="times"/>
          {{$t('signup.fourCharacters')}}
        </div>
        <div class="validation">
            <font-awesome-icon v-if="usernameValid" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.onlyCharactersAndDigits')}}
        </div>

        <div class="input">
          <div style="flex: 1;"><input v-model="passwordInput" @change="onChange" v-on:keyup.enter="signUp" class="themeInput" type="password" :placeholder="$t('signin.password')"></div>
          <div><font-awesome-icon icon="lock" class="inputImage"/></div>
        </div>
        <div class="validation">
            <font-awesome-icon v-if="passwordLengthOk" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.eightCharacters')}}
        </div>

        <div class="validation">
            <font-awesome-icon v-if="passwordHasNumber" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.containsNumber')}}
        </div>

        <div class="validation">
            <font-awesome-icon v-if="passwordHasUpperCase" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.containsCapital')}}
        </div>

        <div class="validation">
            <font-awesome-icon v-if="passwordHasLowerCase" class="text-green" icon="check"/>
            <font-awesome-icon v-else class="text-red" icon="times"/>
            {{$t('signup.containsLowercase')}}
        </div>
        
        <div v-if="errorMessage" class="w3-panel errorBox w3-round">{{ errorMessage }} <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/></div>
        
      </div>  

      <div class="buttonContainer">
        <div class="link"><br/><router-link to="/sign-in" class="specialLink">{{$t('signup.accountAvailable')}}</router-link></div>
        <div class="flex"><button class="button-default" @click="register">{{$t('signup.register')}}</button></div>
      </div>
    </div>

    <div class="dummy-space"></div>
    <router-link to="/" class="bottomLogo"><img src="../../assets/img/CA_Logo_black.png" alt="Chess Administrator" class="logo-header"> Chess Administrator</router-link>
  </div>  
</template>

<script>
//import {Auth} from "@aws-amplify/auth";
//import msal from 'vue-msal'
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const path = '/Authentication/Register';

export default {
  name: 'SignUp',
  data: function () {
    return {
      backgroundKnight: {
        backgroundImage: 'url(' + require('../../assets/img/KnightLeft.png') + ')',
        'background-size': '22px',
        'background-repeat': 'no-repeat',
        'background-position': '-4px 14px'
      },
      snowKnight: {
        backgroundImage: 'url(' + require('../../assets/img/KnightSnow.png') + ')',
        'background-size': '32px',
        'background-repeat': 'no-repeat',
        'background-position': '-8px 10px'
      },
      emailInput: "",
      usernameInput: "",
      passwordInput: "",
      errorMessage: ""
    }
  },
  mounted() {
    this.focusInput();
  },
  computed: {
    usernameLengthOk() {
      return this.usernameInput.length >= 4;
    },
    usernameValid() {
      return /^[a-zA-Z0-9]+$/.test(this.usernameInput);
    },
    emailValid() {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.emailInput);
    },
    passwordLengthOk() {
      return this.passwordInput.length >= 8;
    },
    passwordHasNumber() {
      return /\d/.test(this.passwordInput);
    },
    passwordHasUpperCase() {
      return /[A-Z]/.test(this.passwordInput);
    },
    passwordHasLowerCase() {
      return /[a-z]/.test(this.passwordInput);
    },
    seasonLogo: function() {
      var today = new Date();
      console.log('month: ' +today.getMonth());
      if (today.getMonth() == 11) {
        return this.snowKnight;
      } else
      {
        return this.backgroundKnight;
      }                           
    }  
  },
  methods: {
    register() {
      let that = this
      const myInit = { 
        body: {
          Username: this.usernameInput,
          Password: this.passwordInput,
          Email: this.emailInput
        },
        response: false, 
      };

      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
          console.log("Registered. Give e-mail confirmation message." + JSON.stringify(response));
          that.$router.push("/sign-in?ontheside=confirmationawaiting");
        })
        .catch(error => {
          console.log("Data: " + JSON.stringify(error.response.data));
          if (error.response.data.errors == "Email is already in use") {
            this.errorMessage = "het opgegeven emailadres is al in gebruik."
          } else {
            if (error.response.data.errors.DuplicateUserName != null) {
              this.errorMessage = "de opgegeven gebruikersnaam is al in gebruik."
            } else  
              console.log("Error: " + JSON.stringify(error.response));
          }
        });
    },

/*
    signUp() {
      let that = this
      Auth.signUp({
        username: this.usernameInput,
        password: this.passwordInput,
        attributes: {
          email: this.emailInput
        }
      }).then(function () {
        that.$router.push('/sign-up-confirm/' + encodeURIComponent(that.usernameInput))
      }).catch(function (error) {
        switch (error.name) {
          case "UsernameExistsException":
            that.errorMessage = "name already exists"
            break;
          default:
            that.errorMessage = error.log
        }
      });
    },
    signUpMSAL() {
      let that = this;
      
      msal.signUp(
        this.usernameInput, 
        this.passwordInput,
        {email: this.emailInput})
        .then(function() {
          that.$router.push('/sign-up-confirm/' + encodeURIComponent(that.usernameInput))
        }).catch(function(error) {
          console.log(error);
          switch ("Error: " + error.name) {
            case "UsernameExistsException":
              that.errorMessage = "naam bestaat al"
              break;
            default:
              that.errorMessage = error.log
          }
        });
    },
*/
    home() {
      this.$router.push('/')
    },
    focusInput() {
      var x = document.getElementById("emailField");
      x.focus();
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottomLogo {
  padding-left: 10px;
}
.container {
  margin-bottom: 12px;
}

.fieldsContainer {
  position: relative;
  display: flex;
  flex-direction: column;
}

.link {
  margin-top: 1em;
}

.validation {
  margin-left: 1vw;
}

.fieldsContainer {
  width: 100%;
  box-sizing: border-box;
}

/* mobile */
@media screen and (max-width: 600px) {
  .fieldsContainer {
    width: 100%;
    padding: 0;
  }

  .validation {
    margin-left: 2vw;
    font-size: 0.9em;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .fieldsContainer {
    width: 100%;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .fieldsContainer {
    width: 100%;
  }
}
</style>
